import React from 'react';
import { isRouteErrorResponse, Navigate, useRouteError } from 'react-router-dom';

import { ErrorPage } from '../components/ErrorPage';

const RootBoundary = () => {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        console.error('ROUTER ERROR');

        if (error.status === 404) {
            console.error('ROUTER | PAGE NOT FOUND');
        }

        return <Navigate to="/" />;
    }

    return <ErrorPage />;
};

export default RootBoundary;
